// @ts-nocheck
/* eslint-disable */

// THIS IS AN AUTOGENERATED FILE
import * as React from 'react';
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { memo } from 'react';

const SvgTogglePadLabels = (props: SvgIconProps) => {
	const { sx, ...other } = props;
	return (
		<SvgIcon
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 24 24'
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			preserveAspectRatio='xMidYMid meet'
			sx={{ ...sx, padding: '0px' }}
			{...other}
		>
			<path d='M15.874 10h-3.49l-.73 2h-1.62l3.4-9h1.4l3.41 9h-1.63l-.74-2Zm-3.04-1.26h2.61l-1.3-3.83-1.31 3.83Z' />
			<rect width={2} height={22} rx={0} ry={0} transform='matrix(1 0 0 .86364 4 5)' />
			<rect width={4} height={2} rx={0} ry={0} transform='matrix(1.5 0 0 1 0 3)' />
			<rect width={16} height={5} rx={0} ry={0} transform='matrix(.875 0 0 1 6 15)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 3 6)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 3 10)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 3 14)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 3 17.5)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 3 21)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 2 22)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 1 23)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 1 19.5)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 1 16)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 1 12)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 1 8)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 2 18.5)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 2 15)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 2 11)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 2 7)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 4 20)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 4 16.5)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 4 13)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 4 9)' />
			<rect width={1.5} height={2} rx={0} ry={0} transform='matrix(-.66667 0 0 .5 4 5)' />
		</SvgIcon>
	);
};

const Memo = memo(SvgTogglePadLabels) as any as () => JSX.Element;
export default Memo;
